import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";
import { ModuleNameHr, PageRoute, QueryParam } from "../../../models";
import { formatNumber, stringifyURI } from "../../../services";
import { getImageUrl } from "../../../services/asset";
import IndexImage from "../../IndexImage";
import styles from "./categorySection.scss";
import { CategoriesI } from "../../../typings/routesTypes";
import AgeVerification from "../../../components/AgeVerificationModal";
import history from "../../../history";
import { selectIsAgeVerified } from "../../../routes/Ad/ad.ducks";

const CategorySection = ({ categories, module }) => {
  const [showImages, setshowImages] = useState(true);
  const [ageVerificationModal, setAgeVerificationModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const isAgeVerified = useSelector(selectIsAgeVerified);
  const location = useLocation();

  useEffect(() => {
    // Hide icons in the mobile phones category
    if (location.pathname.includes(ModuleNameHr.mobilePhones)) {
      setshowImages(false);
    } else {
      setshowImages(true);
    }
  }, [location.pathname]);

  const renderSearchAll = () => {
    if(!location.pathname.includes(ModuleNameHr.mobilePhones)) {
      return null;
    }
    const searchLink = `/${ModuleNameHr.mobilePhones}${
      PageRoute.search
    }${stringifyURI({
      module: ModuleNameHr.mobilePhones
    }, QueryParam.searchQuery)}`;

    return (
      <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={8}
          className={styles.categoryContainer}
        >
        
        <Link 
          to={searchLink} 
          title={"Sve kategorije"}
          className={`${styles.category} ${styles.allName}`}
        >
          <div className={styles.hiddenImage}></div>
          <div className={styles.categoryInfoContainer}>
              <span>
                <span className={styles.categoryName}>
                   {"Sve kategorije"}
                </span>
              </span>
            </div>
        </Link>
      </Col>
    );
  };

  const orderCategories = (categories, module) => {
    if ( module === ModuleNameHr.mobilePhones) {
      return [...categories].sort((a, b) => {
        const nameA = a.displayName.toUpperCase();
        const nameB = b.displayName.toUpperCase();
        return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
      });
    }else if(module === ModuleNameHr.realEstate){
      return [...categories];
    }else{
      return [...categories].sort((l1, l2) => l2.count - l1.count);
    }
  };

  const handleAgeVerificationOk = () => {
    setAgeVerificationModal(false);
    if (pendingNavigation) {
      history.push(pendingNavigation);
      setPendingNavigation(null);
    }
  };

  const handleAgeVerificationCancel = () => {
    setAgeVerificationModal(false);
    setPendingNavigation(null);

    // Go back one step in history if history exists, otherwise go to homepage
    if (location.key && location.key !== "default") {
      history.goBack();
    } else {
      history.push(PageRoute.home);
    }
  };

  return (
    <React.Fragment>
      {ageVerificationModal && (
        <AgeVerification
          onOk={handleAgeVerificationOk}
          onCancel={handleAgeVerificationCancel}
        />
      )}
      <Row gutter={20} className={styles.container}>
        {renderSearchAll()}
        {orderCategories(categories, module).map((category: CategoriesI) => (
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            xl={8}
            key={category.name}
            className={styles.categoryContainer}
          >
            <Link
              to={`/${category.moduleRoute}/${category.route}`}
              title={category.displayName}
              className={styles.category}
            >
              {showImages ? (
                <IndexImage
                  className={styles.categoryImage}
                  alt={category.displayName}
                  src={`${getImageUrl(category.name)}.png`}
                />
              ) : (
                <div className={styles.hiddenImage}></div>
              )}
              <div className={`${styles.categoryInfoContainer}
                            ${showImages ? styles.inlineData : styles.centerData}`}>
                  <span className={styles.categoryName}>
                    {category.displayName}
                  </span>

                  {category.count > 0 ? (
                    <span className={styles.categoryCount}>
                      {formatNumber(category.count)}
                    </span>
                  ) : null}
              </div>
            </Link>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default CategorySection;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/CategorySection/CategorySection.tsx